export default "__VITE_ASSET__a6d8ae76__"